import { isInt } from '../is-int/is-int';

/**
 * A specialized type guard that checks if `dates` is a list consisting of `Date` objects.
 * Additionally, by specifying `length`, we can also check, if we want, how many elements it contains.
 * @param dates
 * @param length
 */
export function isDateArray(dates: unknown, length?: number): dates is Date[] {
  const result = Array.isArray(dates) && dates.every(value => value instanceof Date);

  if (isInt(length)) {
    return result && dates.length === length;
  }

  return result;
}
